import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { IApiResponse } from "../../../utils/types/api-response";
import {
    createNoteRuleBypass,
    updateNoteRuleBypassStatus,
} from "../services/note-rule-bypass.services";
import {
    ICreateNoteRuleBypassPayload,
    INoteRuleBypass,
    IUpdateNoteRuleBypassStatusPayload,
} from "../types/note-rule-bypass.types";

export function useCreateNoteRuleBypass() {
    return useMutation<
        IApiResponse<INoteRuleBypass>,
        AxiosError<IApiResponse<INoteRuleBypass>>,
        ICreateNoteRuleBypassPayload
    >({
        mutationKey: ["create-note-rule-bypass"],
        mutationFn: (payload) => createNoteRuleBypass(payload),
    });
}

export function useUpdateNoteRuleBypassStatus() {
    return useMutation<
        IApiResponse<Pick<INoteRuleBypass, "bypass_id" | "status">>,
        AxiosError<IApiResponse<Pick<INoteRuleBypass, "bypass_id" | "status">>>,
        IUpdateNoteRuleBypassStatusPayload
    >({
        mutationKey: ["update-note-rule-bypass-status"],
        mutationFn: (payload) => updateNoteRuleBypassStatus(payload),
    });
}
